// removed by extract-text-webpack-plugin
module.exports = {"image-loader":"image-loader","opened":"opened","ratio100":"ratio100","ratio90":"ratio90","ratio80":"ratio80","ratio70":"ratio70","ratio60":"ratio60","ratio50":"ratio50","ratio40":"ratio40","ratio30":"ratio30","ratio20":"ratio20","ratio10":"ratio10","image-loader__box":"image-loader__box"};


//////////////////
// WEBPACK FOOTER
// ./src/components/image-loader/styles.css
// module id = 718
// module chunks = 0 1